import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { EventReminder } from 'types/api/changes'
import { getDefaultTimezone } from 'index'

dayjs.extend(utc)
dayjs.extend(timezone)

export function generateDefaultReminder(
  allDay?: boolean,
  startTime?: string
): EventReminder {
  let alertTime = ''
  let offset = 60 * 60 // default offset for non-all-day events

  if (allDay && startTime) {
    // startTime is UTC epoch of the event day
    // We want to set alert at 9 AM in user's timezone on that day
    const userTimezone = getDefaultTimezone()
    const utcDate = dayjs.unix(Number(startTime)).utc()

    // Create 9 AM in user's timezone for that day
    const nineAmUserTz = utcDate
      .tz(userTimezone)
      .set('hour', 9)
      .set('minute', 0)
      .set('second', 0)

    alertTime = String(nineAmUserTz.unix())
    // Get user's timezone offset in seconds
    offset = -nineAmUserTz.utcOffset() * 60
  }

  return {
    AlertTime: alertTime,
    isOn: '1',
    isRelativeReminder: allDay ? '0' : '1',
    offset
  }
}
